@if (loading()) {
  <mat-spinner [diameter]="24"></mat-spinner>
} @else {
  <mat-form-field appearance="outline" class="country-select-field">
    <mat-select
      [formControl]="countriesControl"
      multiple
      [required]="required"
      [placeholder]="placeholder"
      panelClass="country-select-panel"
      (openedChange)="onPanelOpenedChange($event)">
      <mat-select-trigger>
        @if (selectedCount() > 0 && selectedCount() <= 10) {
          {{ selectedLabel() }}
        } @else if (selectedCount() > 10) {
          {{ selectedCount() }} {{ "countrySelect.selected" | translate }}
        }
      </mat-select-trigger>

      <!-- Search input (disabled so it doesn't appear as a selectable option) -->
      <mat-option disabled class="country-search-option">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          #searchInput
          [formControl]="searchControl"
          [placeholder]="'countrySelect.filterByName' | translate"
          (keydown)="$event.stopPropagation()"
          (click)="$event.stopPropagation()" />
      </mat-option>

      @for (item of displayItems(); track item.key) {
        @if (item.type === "selected-header") {
          <mat-option disabled class="selected-header-option">
            <span class="selected-label">{{ "countrySelect.selectedCountries" | translate }}</span>
          </mat-option>
        } @else if (item.type === "continent") {
          <mat-option [value]="item.key" class="continent-header-option" (onSelectionChange)="onContinentSelect(item.key, $event)">
            <span class="continent-label">{{ item.value }}</span>
            <mat-icon class="expand-icon">{{ item.isExpanded ? "expand_less" : "expand_more" }}</mat-icon>
          </mat-option>
        } @else {
          <mat-option [value]="item.key" class="country-option">{{ item.value }}</mat-option>
        }
      }
    </mat-select>
  </mat-form-field>
}
